import React from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Download } from '../../../_lib/components/Download';
import { Heading } from '../../../_lib/components/Heading/Heading';
import { CsvExport } from '../views/MostPopularPagesStatisticsView';

export function MostPopularPagesExport({ last30DayReport, monthlyReports }: CsvExport) {
  const { t } = useSonTranslation('MostPopularPages');

  return (
    <div className="most-popular-pages-statistics-view__export">
      <section className="most-popular-pages-statistics-view__export-section">
        <Heading hierarchy={3}>{t('export.last30DaysHeadline')}</Heading>
        <ul className="most-popular-pages-statistics-view__export-list">
          <li className="most-popular-pages-statistics-view__export-list-item">
            <Download
              url={last30DayReport.url}
              fileName={last30DayReport.fileName}
              fileExtension={last30DayReport.fileExtension}
              mimeType={last30DayReport.mimeType}
              fileSizeBytes={last30DayReport.fileSizeBytes}
              approximateFileSize={last30DayReport.isApproximateSize}
            />
          </li>
        </ul>
      </section>
      <section className="most-popular-pages-statistics-view__export-section">
        <Heading hierarchy={3}>{t('export.monthlyHeadline')}</Heading>
        <ul className="most-popular-pages-statistics-view__export-list">
          {monthlyReports.map(monthlyReport => (
            <li key={monthlyReport.url} className="most-popular-pages-statistics-view__export-list-item">
              <Download
                url={monthlyReport.url}
                fileName={monthlyReport.fileName}
                fileExtension={monthlyReport.fileExtension}
                mimeType={monthlyReport.mimeType}
                fileSizeBytes={monthlyReport.fileSizeBytes}
                approximateFileSize={monthlyReport.isApproximateSize}
              />
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
}
